<template>
  <div id="berita">
    <section class="download-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-7">
            <h2>Informasi dan Berita</h2>
            <p class="lead">
              Informasi dan Berita Aplikasi SiPeDuLi Jembrana
            </p>
          </div>
          <div class="col-md-5 text-right">
            <router-link
              to="/berita"
              class="btn btn-primary btn-lg"
            >
              Rilis Berita
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="before-footer">
      <div class="container">
        <div v-if="!isLoadingBeritaPin">
          <div
            class="row"
            v-if="pin.length > 0"
          >
            <div
              class="col-md-6"
              v-for="h in pin"
              :key="h.id_berita"
            >
              <div
                class="card item-hover long-shadow"
                @click="$router.push({path: '/berita/'+h.slug})"
              >
                <div class="card-body d-flex p-45">
                  <div class="card-icon text-white">
                    <img
                      v-if="h.thumbnail"
                      :src="$store.getters.getBaseUrl+'/api/file/'+h.thumbnail"
                      alt=""
                    >
                    <img
                      v-else
                      :src="require('./../../assets/stisla/img/news/img01.jpg')"
                    >
                  </div>
                  <div class="w-100">
                    <h5>{{ h.judul_berita }}</h5>
                    <p class="lh-sm">
                      {{ h.snippet.substr(0, 100) }}
                    </p>
                    <p class="mt-4 text-right">
                      <router-link
                        :to="'/berita/'+h.slug"
                        class="link-icon"
                      >
                        Lihat Selengkapnya <i class="fas fa-chevron-right" />
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div
              class="col-md-6"
              v-for="i in 2"
              :key="i"
            >
              <div class="card item-hover long-shadow">
                <div class="card-body d-flex p-45">
                  <div class="card-icon text-white content-loader">
                    <!-- <img v-else :src="require('./../../assets/stisla/img/news/img01.jpg')"> -->
                  </div>
                  <div class="w-100">
                    <h5 class="content-loader">
                      Judul Berita
                    </h5>
                    <p class="lh-sm content-loader">
                      Deskripsi Berita Deskripsi Berita
                    </p>
                    <p class="mt-4 text-right">
                      <span class="content-loader">Link Berita</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-white pt-5">
      <div class="container">
        <div
          v-if="!isLoadingBeritaHome"
          class="row"
        >
          <div class="col-lg-12">
            <div
              class="features"
              v-if="homepage.length > 0"
            >
              <div
                class="feature"
                v-for="h in homepage"
                :key="h.id_berita"
              >
                <div class="feature-img">
                  <img
                    v-if="h.thumbnail"
                    :src="$store.getters.getBaseUrl+'/api/file/'+h.thumbnail"
                    alt=""
                  >
                  <img
                    v-else
                    :src="require('./../../assets/stisla/img/news/img01.jpg')"
                  >
                </div>
                <h5>
                  <router-link :to="'/berita/'+h.slug">
                    {{ h.judul_berita }}
                  </router-link>
                </h5>
                <p>{{ h.snippet.substr(0, 100) }}</p>
                <div class="mt-4 text-right">
                  <router-link
                    :to="'/berita/'+h.slug"
                    class="link-icon"
                  >
                    Lihat Selengkapnya <i class="fas fa-chevron-right" />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="row"
        >
          <div class="col-lg-12">
            <div class="features">
              <div
                class="feature"
                v-for="i in 6"
                :key="'h-' + i"
              >
                <div class="feature-img content-loader" />
                <h5 class="content-loader">
                  Judul Berita
                </h5>
                <p class="content-loader">
                  Deskripsi berita
                </p>
                <div class="mt-4 text-right">
                  <span class="content-loader">Lihat selengkapnya</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="text-center mt-3 mb-5"
          v-if="page === 'rilis'"
        >
          <button
            id="btnLoadNext"
            class="btn btn-lg btn-primary"
            @click="loadNext"
          >
            <i class="fa fa-sync mr-2" />Lihat Berita Lainnya
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
    #berita {
        margin-bottom: 100px;
    }
    .features {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -25px;
    }
    .features .feature {
        width: calc(100% / 3);
        padding: 25px;
    }
    .features .feature .feature-icon i {
        font-size: 22px;
        margin-bottom: 25px;
    }
    .features .feature .feature-icon {
        background-color: rgba(103,119,239,.1);
        color: #6777ef;
        display: inline-block;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 60px;
        margin-bottom: 20px;
    }
    .features .feature .feature-img img {
        border-radius: 10px;
        width: 100%;
        max-height: 200px;
        margin-bottom:20px;
    }
    @media (max-width: 575.98px){
        #berita {
            margin-bottom: 0px;
        }
        .features {
            margin: 0;
        }
        .features .feature {
            width: 100%;
        }
    }
    .features .feature h5 {
        margin-bottom: 5px;
    }
    .features .feature p {
        margin-top: 10px;
        line-height: 32px;
    }
    .download-section {
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.04);
        margin-bottom: 100px;
        padding: 60px 0;
        height: 350px;
    }
    .download-section .btn {
        border-radius: 3px;
        padding-left: 30px;
        padding-right: 30px;
        height: 60px;
        line-height: 44px;
        font-size: 16px;
    }
    .before-footer {
        padding: 0;
        position: relative;
        z-index: 99;
        margin-bottom: -50px;
        margin-top: -250px;
        background: white;
    }
    .card-icon {
        width: 50px;
        height: 50px;
        border-radius: 3px;
        text-align: center;
        margin-right: 20px;
        flex-grow: 0;
        flex-shrink: 0;
    }
    .card-icon i {
        line-height: 50px;
        font-size: 20px;
    }
    .card.item-hover {
        cursor: pointer;
        transition: all .5s;
    }
    .card.item-hover:hover {
        transform: scale(1.1);
    }
</style>

<script>
export default {
    data() {
        return {
            pin: [],
            homepage: [],
            limit: 6,
            isLoadingBeritaPin: false,
            isLoadingBeritaHome: false
        }
    },
    props: {
      page: {
        type: String,
        default: () => null
      }
    },
    methods: {
        loadNext(){
            let button = document.querySelector('#btnLoadNext')
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
			button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Loading'

            this.limit += 6
            this.$store.dispatch('fetchAllBerita', {limit: this.limit}).then(res => {
                if(res.data.status){
                    this.homepage = res.data.data

                    button.removeAttribute('disabled')
                    button.innerHTML = buttonHtml
                }
            })
        }
    },
    created(){
        this.isLoadingBeritaPin = true
        this.$store.dispatch('fetchBeritaPin').then(res => {
            this.isLoadingBeritaPin = false
            if(res.data.status){
                this.pin = res.data.data
            }
        })
        this.isLoadingBeritaHome = true
        let dispatchBerita = this.$store.dispatch('fetchBeritaHomepage')
        if(this.page === 'rilis'){
            dispatchBerita = this.$store.dispatch('fetchAllBerita', {limit: this.limit})
        }

        dispatchBerita.then(res => {
            this.isLoadingBeritaHome = false
            if(res.data.status){
                this.homepage = res.data.data
            }
        })
    }
}
</script>
